// slide 1 box text prev
document.addEventListener('DOMContentLoaded', function () {
    // Alle Input-Elemente mit der Klasse "pp_input" abrufen
    var inputFields = document.querySelectorAll('.pp_input');

    // Element mit der ID "pp_box-text-prev" abrufen
    var previewElement = document.getElementById('pp_box-text-prev');

    // Funktion zum Aktualisieren der Vorschau und Klassenaufrufe
    function updatePreview() {
        // Vorherigen Inhalt des Vorschau-Elements löschen
        previewElement.innerHTML = '';

        var filledCount = 0;

        // Wert jedes Input-Feldes abrufen und zum Vorschau-Element hinzufügen, wenn der Wert nicht leer ist
        inputFields.forEach(function (inputField, i) {
            if (inputField.value.trim() !== '') {
                var words = inputField.value.trim().split(' ');

                // Add words in groups of 3 or 4, adding a <br> after each group
                for (var j = 0; j < words.length; j++) {
                    previewElement.innerHTML += words[j] + ' ';

                    // Add <br> after every 3rd or 4th word
                    if ((j + 1) % 3 === 0 || (j + 1) % 4 === 0 || j === words.length - 1) {
                        previewElement.innerHTML += '<br>';
                    }
                }
                filledCount++;
            }
        });

        // Klasse für das Vorschau-Element entsprechend der Anzahl der gefüllten Input-Felder hinzufügen
        if (filledCount === 1) {
            previewElement.classList.remove('pp_input-size-2', 'pp_input-size-3');
            previewElement.classList.add('pp_input-size-1');
        } else if (filledCount === 2) {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-3');
            previewElement.classList.add('pp_input-size-2');
        } else if (filledCount === 3) {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-2');
            previewElement.classList.add('pp_input-size-3');
        } else {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-2', 'pp_input-size-3');
        }
    }

    // Ereignislistener für jedes Input-Feld hinzufügen
    inputFields.forEach(function (inputField) {
        inputField.addEventListener('input', updatePreview);
    });

    // Ereignislistener für jeden Herz-Button hinzufügen
    var heartButtons = document.querySelectorAll('.heart_button');
    heartButtons.forEach(function (heartButton) {
        heartButton.addEventListener('click', function () {
            // Herzsymbol zum entsprechenden Input-Feld hinzufügen
            var targetInputId = heartButton.getAttribute('data-target');
            var targetInput = document.querySelector('[target="' + targetInputId + '"]');
            if (targetInput) {
                targetInput.value += '♥';
                // Aktualisiere die Vorschau nach Hinzufügen des Herzsymbols
                updatePreview();
            }
        });
    });
});


// slide 3 letter text prev
document.addEventListener("DOMContentLoaded", function () {
    // Warte auf das Laden der DOM-Struktur

    // Textbereich und Bilder abrufen
    var textarea = document.querySelector('.pp_textarea');
    var imgFirst = document.getElementById('letter_img-first');
    var imgSecond = document.getElementById('letter_img-second');
    var ppLetterTextarea = document.getElementById('pp_letter-textarea');

textarea.addEventListener('input', function () {
    const text = textarea.value;

    // Show/hide images
    if (text.trim() !== '') {
        imgFirst.style.display = 'none';
        imgSecond.style.display = 'inline';
    } else {
        imgFirst.style.display = 'inline';
        imgSecond.style.display = 'none';
    }

    // Update preview with line breaks this was also adjusted
    ppLetterTextarea.innerHTML = text.replace(/\n/g, '<br>');




    // NEW: Resize font based on number of characters
    resizeFontByCharacterCount(ppLetterTextarea, text);
});



    // Funktion zum Aktualisieren der Vorschau und Klassenaufrufe
    function updatePreview() {
        ppLetterTextarea.innerHTML = '';
        var filledCount = 0;

        inputFields.forEach(function (inputField, i) {
            if (inputField.value.trim() !== '') {
                var words = inputField.value.trim().split(' ');

                // Add words in groups of 3 or 4, adding a <br> after each group
                for (var j = 0; j < words.length; j++) {
                    ppLetterTextarea.innerHTML += words[j] + ' ';

                    // Add <br> after every 3rd or 4th word
                    if ((j + 1) % 3 === 0 || (j + 1) % 4 === 0 || j === words.length - 1) {
                        ppLetterTextarea.innerHTML += '<br>';
                    }
                }
                filledCount++;
            }
        });

        if (filledCount === 1) {
            ppLetterTextarea.classList.remove('pp_input-size-2', 'pp_input-size-3');
            ppLetterTextarea.classList.add('pp_input-size-1');
        } else if (filledCount === 2) {
            ppLetterTextarea.classList.remove('pp_input-size-1', 'pp_input-size-3');
            ppLetterTextarea.classList.add('pp_input-size-2');
        } else if (filledCount === 3) {
            ppLetterTextarea.classList.remove('pp_input-size-1', 'pp_input-size-2');
            ppLetterTextarea.classList.add('pp_input-size-3');
        } else {
            ppLetterTextarea.classList.remove('pp_input-size-1', 'pp_input-size-2', 'pp_input-size-3');
        }
    }
});




// schliessen & navigation zwischen den slide folien
document.addEventListener("DOMContentLoaded", function() {
    // Get all pp_button elements
    var ppButtons = document.querySelectorAll('.pp_button');

    // Add click event listeners to each pp_button
    ppButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Get the target value from the clicked button
            var target = button.getAttribute('target');

            // Check if the clicked button is not the REMOVE or FINISH button
            if (!button.classList.contains('pp_reset') && !button.classList.contains('pp_finish')) {
                // Hide all pp_container elements
                hideAllContainers();

                // Show the pp_container with the matching target value
                showContainer(target);
            }
        });
    });

    function hideAllContainers() {
        // Get all pp_container elements
        var ppContainers = document.querySelectorAll('.pp_container');

        // Hide each pp_container
        ppContainers.forEach(function(container) {
            container.style.display = 'none';
        });
    }

    function showContainer(target) {
        // Get the pp_container with the matching target value
        var containerToShow = document.getElementById(target);

        // Show the selected pp_container
        if (containerToShow) {
            containerToShow.style.display = 'flex'; // You can adjust the display style as needed
        }
    }
});




// öffnen des personalizers über den button - zürücksetzen der inputfelder über reset button 
document.addEventListener("DOMContentLoaded", function() {
    // Link mit der Klasse personalization-button
    var personalizeLink = document.querySelector(".personalization-button");
    personalizeLink.addEventListener("click", function() {
        // Modal einblenden
        var modal = document.getElementById("modal-personalization");
        modal.style.display = "flex"; // oder "block", je nach Ihren Layout-Anforderungen
    });

    // Link mit der Klasse pp_button button_outline pp_reset
    var resetLinks = document.querySelectorAll(".pp_button.button_outline.pp_reset");
    resetLinks.forEach(function(resetLink) {
        resetLink.addEventListener("click", function() {
            // Inhalte aller Input-Felder zurücksetzen
            resetInputFields();

            // Modal ausblenden
            var modal = document.getElementById("modal-personalization");
            modal.style.display = "none";
        });
    });

    // Close-Button (svg#close_pp-wrapper)
    var closeBtn = document.getElementById("close_pp-wrapper");
    closeBtn.addEventListener("click", function() {
        // Modal ausblenden, Input-Felder und Textarea-Feld behalten
        var modal = document.getElementById("modal-personalization");
        modal.style.display = "none";
    });

    // Link mit der Klasse pp_button pp_finish
    var finishLink = document.querySelector(".pp_button.pp_finish");
    finishLink.addEventListener("click", function() {
        // Modal ausblenden
        var modal = document.getElementById("modal-personalization");
        modal.style.display = "none";

      //Get personalization
        const inputs = modal.querySelectorAll('input');
        const textareas = modal.querySelectorAll('textarea');
        const nameData = [];
        const inputData = [];
        inputs.forEach((input, index) => {
            nameData.push(input.name);
            inputData.push(input.value);
        });
        textareas.forEach((textarea, index) => {
            nameData[inputs.length + index] = textarea.name;
            inputData[inputs.length + index] = textarea.value;
        });

        // Select all input elements
        const inputDatas = document.querySelectorAll('.p--data');
        // Remove each input
        inputDatas.forEach(d => d.remove());

        // var personalizationHTML = '';
        var element  = document.getElementById(FormID);
        inputData.forEach((val, i) => {
            // personalizationHTML += '<input type="hidden" name="'+nameData[i]+'" value="'+val+'">';
            const input = document.createElement('input');
            input.type = 'hidden';
            input.className = 'p--data';
            input.name = nameData[i];
            input.value = val;
            element.appendChild(input);
        });

        // const element  = document.getElementById(FormID);
        // element.innerHTML = '<p>sdfsdf</p>';

        // Auto-trigger Add to Cart
        setTimeout(function() {
            var atcButton = document.querySelector('[data-add-to-cart]');
            if (atcButton) atcButton.click();
        }, 100);
    });

    // Funktion zum Zurücksetzen der Input-Felder
    function resetInputFields() {
        var inputFields = document.querySelectorAll(".pp_input");
        inputFields.forEach(function(input) {
            input.value = "";
        });

        // Textarea-Feld zurücksetzen
        var textareaField = document.querySelector(".pp_textarea");
        textareaField.value = "";

        // Inhalte der <span>-Elemente zurücksetzen
        var boxTextPrev = document.getElementById("pp_box-text-prev");
        boxTextPrev.textContent = "";

        var letterTextarea = document.getElementById("pp_letter-textarea");
        letterTextarea.textContent = "";
    }

    // Beobachter für Änderungen an #show-personalization
    var targetNode = document.getElementById('show-personalization');
    var observerOptions = {
        attributes: true,
        attributeFilter: ['style']
    };

    var observerCallback = function(mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                var target = mutation.target;
                if (window.getComputedStyle(target).display === 'none') {
                    resetInputFields();
                }
            }
        }
    };

    var observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, observerOptions);
});



document.addEventListener('DOMContentLoaded', function () {
    // Alle Input-Elemente mit der Klasse "pp_input" abrufen
    var inputFields = document.querySelectorAll('.pp_input');

    // Element mit der ID "pp_box-text-prev" abrufen
    var previewElement = document.getElementById('pp_box-text-prev');

    // Funktion zum Überprüfen und Hervorheben des Herzsymbols
    function highlightHeart() {
        var previewContent = previewElement.innerHTML;

        // Überprüfe, ob das Herzsymbol enthalten ist und färbe es rot
        if (previewContent.includes('♥')) {
            previewContent = previewContent.replace(/♥/g, '<span class="highlight">♥</span>');
            previewElement.innerHTML = previewContent;
        }
    }

    // Überprüfung der Herzen im Input-Feld bei Änderungen in allen Input-Feldern
    function updatePreview() {
        // Vorherigen Inhalt des Vorschau-Elements löschen
        previewElement.innerHTML = '';

        var filledCount = 0;

        // Wert jedes Input-Feldes abrufen und zum Vorschau-Element hinzufügen, wenn der Wert nicht leer ist
        inputFields.forEach(function (inputField, i) {
            if (inputField.value.trim() !== '') {
                var words = inputField.value.trim().split(' ');

                // Add words in groups of 3 or 4, adding a <br> after each group
                for (var j = 0; j < words.length; j++) {
                    previewElement.innerHTML += words[j] + ' ';

                    // Add <br> after every 3rd or 4th word
                    if ((j + 1) % 3 === 0 || (j + 1) % 4 === 0 || j === words.length - 1) {
                        previewElement.innerHTML += '<br>';
                    }
                }
                filledCount++;
            }
        });

        // Klasse für das Vorschau-Element entsprechend der Anzahl der gefüllten Input-Felder hinzufügen
        if (filledCount === 1) {
            previewElement.classList.remove('pp_input-size-2', 'pp_input-size-3');
            previewElement.classList.add('pp_input-size-1');
        } else if (filledCount === 2) {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-3');
            previewElement.classList.add('pp_input-size-2');
        } else if (filledCount === 3) {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-2');
            previewElement.classList.add('pp_input-size-3');
        } else {
            previewElement.classList.remove('pp_input-size-1', 'pp_input-size-2', 'pp_input-size-3');
        }

        // Führe die Herzüberprüfung aus
        highlightHeart();
    }

    // Überprüfung der Herzen im Input-Feld bei regelmäßigen Intervallen
    setInterval(highlightHeart, 1000);

    // Initialisierung
    updatePreview();
});

/*Letter adjustments */

function resizeFontByCharacterCount(container, text, desktopBase = 22, mobileBase = 18, minFontSize = 10, shrinkAfter = 100) {
  const isMobile = window.innerWidth <= 768;
  const baseFontSize = isMobile ? mobileBase : desktopBase;

  let newFontSize = baseFontSize;
  const charCount = text.length;

  if (charCount > shrinkAfter) {
    const excess = charCount - shrinkAfter;
    newFontSize -= Math.floor(excess / 10);
    newFontSize = Math.max(newFontSize, minFontSize);
  }

  container.setAttribute("style", `font-size: ${newFontSize}px !important`);
}


